// src/components/AuthLayout.js
import React from 'react';

export default function AuthLayout({ children, title }) {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {title && (
          <div style={styles.header}>
            <img src="/yabatho-logo.png" alt="YaBatho" style={styles.logo} />
            <h2 style={styles.title}>{title}</h2>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F7F3EA',
  },
  card: {
    width: 400,
    padding: 30,
    backgroundColor: '#FFFDF7',
    borderRadius: 8,
    border: '1px solid #E6D8BE',
    boxShadow: '0 18px 44px rgba(15, 61, 46, 0.12)',
  },
  header: {
    textAlign: 'center',
    marginBottom: 22,
  },
  logo: {
    width: 190,
    height: 76,
    objectFit: 'contain',
    marginBottom: 12,
  },
  title: {
    color: '#0F3D2E',
    margin: 0,
  },
};
